module.exports = __webpack_public_path__ + "images/tft-pricing-banner-bg.webp";